import { usePageTitle } from '../hooks/usePageTitle';

export default function NotFound() {
  usePageTitle("Not Found — Chuck's Mojito Shack");

  return (
    <div className="container page-content py-5">
      <h3>Not Found</h3>
      <p>Sorry, the content you are looking for does not exist.</p>
    </div>
  );
}
